import { IStepOption } from 'ngx-ui-tour-md-menu';

export const TOUR_STEPS: IStepOption[] = [
  {
    anchorId: 'userPanel',
    title: 'User Profile',
    content:
      'This is your user profile, from here you can switch theme (Black/White), update your name, contact details & personal settings.',
    enableBackdrop: true,
    endBtnTitle: 'Exit Tour',
    nextBtnTitle: 'Next',
  },
  {
    anchorId: 'clientSwitcher',
    title: 'Catalogue Switcher',
    content: 'This dropdown allows you to change catalogue.',
    enableBackdrop: true,
    isOptional: true,
    nextBtnTitle: 'Got it',
    endBtnTitle: 'Exit Tour',
  },
  {
    anchorId: 'cartButton',
    title: 'Shopping Cart',
    content:
      'The cart can be accessed by clicking the cart icon. The number of items in the cart is displayed on the cart icon.',
    enableBackdrop: true,
    isOptional: true,
    endBtnTitle: 'Exit Tour',
    nextBtnTitle: 'Next',
  },
  {
    anchorId: 'menuSidebarToggle',
    title: 'Main Menu Toggle',
    content: 'This button allows you to open main menu.',
    placement: { xPosition: 'after' },
    enableBackdrop: true,
    endBtnTitle: 'Exit Tour',
    nextBtnTitle: 'Next',
  },
  {
    anchorId: 'menuSidebar',
    title: 'Main Menu',
    content: 'This is the main Menu, this is where you will navigate around VIDA',
    placement: { xPosition: 'after', horizontal: true },
    enableBackdrop: true,
    isOptional: true,
    endBtnTitle: 'Exit Tour',
    nextBtnTitle: 'Next',
  },
  {
    anchorId: 'menuAssets',
    title: 'Assets',
    content: 'The Assets page is where you will find all of the assets in this catalogue.',
    placement: { xPosition: 'after', horizontal: true },
    enableBackdrop: true,
    isOptional: true,
    endBtnTitle: 'Exit Tour',
    nextBtnTitle: 'Next',
  },
  {
    anchorId: 'menuLibrary',
    title: 'Library',
    content: 'Library allows you to build and browse virtual folder structures for your assets.',
    placement: { xPosition: 'after', horizontal: true },
    enableBackdrop: true,
    isOptional: true,
    endBtnTitle: 'Exit Tour',
    nextBtnTitle: 'Next',
  },
  {
    anchorId: 'searchBar',
    title: 'Search',
    content:
      "Search, the search field on the top bar will perform a 'similar' search across all fields. A 'similar' search allows for typos and spelling mistakes.",
    enableBackdrop: true,
    nextOnAnchorClick: true,
    endBtnTitle: 'Exit Tour',
    nextBtnTitle: 'Next',
    isOptional: true,
  },
  {
    anchorId: 'advancedSearch',
    title: 'Advanced Search',
    content:
      'For exact match searching use the fields in the dropdown, these will return exact matches and matches that contain what you search for in only the field used. Multiple fields can be used to create complex search criteria.',
    placement: { xPosition: 'after', horizontal: true },
    enableBackdrop: true,
    isOptional: true,
    endBtnTitle: 'Exit Tour',
    nextBtnTitle: 'Next',
  },
  {
    anchorId: 'searchListSettings',
    title: 'List Settings',
    content: 'The columns on the list view can be customised using the settings icon.',
    enableBackdrop: true,
    isOptional: true,
    endBtnTitle: 'Exit Tour',
    nextBtnTitle: 'Next',
  },
  {
    anchorId: 'searchOpenAsset',
    title: 'Open Asset',
    content: 'Select an asset to preview',
    placement: { yPosition: 'above', xPosition: 'before' },
    nextOnAnchorClick: true,
    enableBackdrop: true,
    isOptional: true,
    endBtnTitle: 'Exit Tour',
  },
  {
    anchorId: 'assetsPreviewPlayer',
    title: 'Asset Preview',
    content: 'The player allows you to preview a proxy of your assets.',
    placement: { xPosition: 'after', horizontal: true },
    enableBackdrop: true,
    isOptional: true,
    endBtnTitle: 'Exit Tour',
    nextBtnTitle: 'Next',
  },
  {
    anchorId: 'assetsPreviewMetadata',
    title: 'Asset Metadata',
    content: 'Asset Metadata is also displayed here.',
    placement: { xPosition: 'before', horizontal: true },
    enableBackdrop: true,
    isOptional: true,
    endBtnTitle: 'Exit Tour',
    nextBtnTitle: 'Next',
  },
  {
    anchorId: 'assetsPreviewAddToCart',
    title: 'Add to Cart',
    content: 'Assets can be added the cart using the add to cart button.',
    placement: { yPosition: 'above' },
    enableBackdrop: true,
    isOptional: true,
    endBtnTitle: 'Finish Tour',
  },
];
